import {BaseUnitHistory} from '../models';

export interface BaseUnitHistoryResponse {
  data: BaseUnitHistory[];
  count: number;
  total: number;
  page: number;
  pageCount: number;
}
